module.exports = __webpack_public_path__ + "img/lifting_technique_button.911178f0.jpg";